/**
 * Controls the hiding of the header on scrolling down
 * @type {StickyHeader}
 */
export class StickyHeader {
    constructor() {
        this.header = document.querySelector('.js__header')
        this.mainNav = this.header.querySelector('.js__main-nav')
        this.headerTotalHeight = this.header.clientHeight + this.mainNav.clientHeight
        this.isStickyHeaderVisible = false
        this.isInitial = false

        if (this.header) {
            this.controlStickyHeader()
        }
    }

    /**
     * Adds ore removes the visibility class depending on the scroll direction
     */
    controlStickyHeader() {
        window.addEventListener('scrollDown', () => {
            if (this.isStickyHeaderVisible) {
                this.header.classList.remove('header--sticky--visible')
                this.isStickyHeaderVisible = false
            }
        })

        window.addEventListener('scrollUp', () => {
            if (!this.isStickyHeaderVisible) {
                this.header.classList.add('header--sticky--visible')
                this.isStickyHeaderVisible = true
            }

            // Handle is-header-sticky-visible__at-page-top
            if (this.isStickyHeaderVisible && window.scrollY < this.headerTotalHeight) {
                this.header.classList.add('js__is-header-sticky-visible__at-page-top')
            } else {
                this.header.classList.remove('js__is-header-sticky-visible__at-page-top')
            }
        })
    }
}
